import { render, staticRenderFns } from "./QuoteDetailSubmenu.vue?vue&type=template&id=5ce6f17c"
import script from "./QuoteDetailSubmenu.vue?vue&type=script&lang=js"
export * from "./QuoteDetailSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports